var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getProp('badgeText'))?_c('b-badge',{staticStyle:{"scale":"1.1"},attrs:{"variant":_vm.getProp('badgeVariant')}},[_vm._v(" "+_vm._s(_vm.getProp('badgeText'))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }